module.exports = __webpack_public_path__ + "static/media/github.bbbb89f0.png";